import request from "@/api/request"


// 获取体检报告列表
export function getReports(id) {
    return request.get("/api/report/ExamRecords", {
        params: {
            profileId: id
        }
    });
}

// 获取体检报告详情
export function getReport(reportId) {
    return request.get("api/report/query", {
        params: {
            tjbh: reportId
        }
    });
}

//获取体检报告历史对比数据
export function getReportCompareData(tjbh) {
    return request.get("api/report/compare", {
        params: {
            tjbh: tjbh
        }
    });
}


// 获取体检报告PDF
export function getPdfReport(reportKey) {
    return request.get("api/report/pdfReport", {
        params: {
            reportKey: reportKey
        }
    });
}

// 获取外送或其它类型的报告
export function getExtReports(id) {
    return request.get("api/report/ExternalReports", {
        params: {
            profileId: id
        }
    });
}